var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import * as S from './style';
import Image from '../../../components/loggedout/common/Image';
import { ESPIcon, ELPIcon } from '../image-cdn-urls';
import { getItemFromLocalStorage, sendEventUsingAvo } from '../../../utils/web-helper';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { EARLY_LEARNING_PROGRAM } from '../../../constant-data/constants';
import { appendBaseParams } from '../../../utils/avo-helper';
export var ProgramSelectionScreen = function (props) {
    var childName = getItemFromLocalStorage('tutoringChildName');
    var programData = [
        {
            icon: ELPIcon,
            id: "ELP",
            name: "Early Learning Program",
            age: "Under 6 years old"
        },
        {
            icon: ESPIcon,
            id: "ESP",
            name: "Elementary School Program",
            age: "6 years and older"
        }
    ];
    var setValue = useExtendedLocalStorage('splashverse-onboarding', '').setValue;
    var programClickHandler = function (id) {
        var card = document.getElementById("card-".concat(id));
        card.classList.add('active');
        setTimeout(function () {
            card.classList.remove('active');
            setValue('selectedProgram', id);
            sendEventUsingAvo({ methodName: 'interactedProgramSelectionScreen', params: __assign({ 'clickedOn': id == EARLY_LEARNING_PROGRAM ? 'Early Learning' : 'Elementary School' }, appendBaseParams({ settings: {}, courses: [], mathGrade: "", elaGrade: "", grade: "", signupFlow: "" })) });
            var opt = { programName: id };
            props.goToNextHandler('program_selection_screen', opt);
        }, 1600);
    };
    useEffect(function () {
        sendEventUsingAvo({ methodName: 'viewedProgramSelectionScreen', params: appendBaseParams({ settings: {}, courses: [], mathGrade: "", elaGrade: "", grade: "", signupFlow: "" })
        });
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Heading, null,
            "Select a learning program for ",
            childName),
        React.createElement(S.SubHeading, null, "You can change it anytime from the Settings menu"),
        React.createElement(S.CardsWrapper, null, programData.map(function (data, index) { return (React.createElement(S.Card, { key: index, onClick: function () { return programClickHandler(data.id); }, id: "card-".concat(data.id) },
            React.createElement(S.CardIcon, null,
                React.createElement(Image, { src: data.icon, alt: data.name })),
            React.createElement(S.CardHeading, null, data.name),
            React.createElement(S.CardDescription, null, data.age))); }))));
};
export default ProgramSelectionScreen;
